import { formatCertifiedMailNumber } from '../../../../lib/misc'
import { truncateString } from '../../../../lib/script'
import HoverWrapperInfo from '../../../wrappers/HoverWrapperInfo'

const MAX_VISIBLE_CHARS = 12

export default function CertifiedMailNumber({ value }) {
    const full = formatCertifiedMailNumber(value)

    if (!full) {
        return '-'
    }

    if (full.length <= MAX_VISIBLE_CHARS) {
        return full
    }

    return (
        <HoverWrapperInfo modalText={full}>
            {truncateString(full, MAX_VISIBLE_CHARS)}
        </HoverWrapperInfo>
    )
}
